define([
    "./hereMapsModule",
    "text!./hereMaps.html",
], function (hereMapsModule, hereMapsView) {
    "use strict";

    // seguir a interface interfaceHere.ts
    return hereMapsModule.directive("hereMaps", [function () {
        return {
            restrict: "E",
            template: hereMapsView,
            scope: {
                maps: "=",
                markersData: "=?",
                polygonsData: "=?",
                routesData: "=?"
            },
            controller: "hereMapsController"
        };
    }]);
});